import { useQuery } from 'react-query'

import { SolutionTypeTemplate } from '@dc-shared-web/hooks/api/solutionType'
import { fetchSolutionTypes } from '@dc-shared-web/hooks/api/solutionType/fetchSolutionType'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

const QUERY_KEY = ['solution-type-templates']

export const useGetSolutionTypeTemplates = () => {
  const apiClient = useAxiosContext()

  const queried = useQuery<SolutionTypeTemplate[], Error>(QUERY_KEY, () =>
    fetchSolutionTypes(apiClient)
  )

  const mappedData = {} as {
    [key: string]: SolutionTypeTemplate
  }
  queried.data?.forEach((solutionTypeTemplate) => {
    mappedData[solutionTypeTemplate.uuid] = solutionTypeTemplate
  })

  return { ...queried, mappedData }
}
